// src/component/PaginaRevista/imagenesRevista.js
function importAll(r) {
  return r.keys().map(r);
}

export const imagenesCapacitaciones = importAll(
  require.context('../../assets/Capacitaciones', true, /\.(png|jpe?g|svg)$/)
);